import { render, staticRenderFns } from "./DurationBreakdownChart.vue?vue&type=template&id=f681b70c"
import script from "./DurationBreakdownChart.vue?vue&type=script&lang=js"
export * from "./DurationBreakdownChart.vue?vue&type=script&lang=js"
import style0 from "./DurationBreakdownChart.vue?vue&type=style&index=0&id=f681b70c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports